import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { HrSetTermTypeStatusPayload } from 'api/actions/hr-set-term-type-status/hr-set-term-type-status-payload';
import { HrSetTermTypeStatusPathParameters } from 'api/actions/hr-set-term-type-status/hr-set-term-type-status-path-parameters';
import { HrSetTermTypeStatusResponse } from 'api/actions/hr-set-term-type-status/hr-set-term-type-status-response';

type HrSetTermTypeStatusQueryParameters = Record<string, any>;

/**
 * The path of the HrSetTermTypeStatus action.
 */
export const hrSetTermTypeStatusActionPath = new SweetPath<keyof HrSetTermTypeStatusPathParameters>(
  '/api/hr/term-types/{termTypeId}/status',
  { path: '{param}' }
);

/**
 * Creates a contextualized HrSetTermTypeStatus actions.
 */
export default function createHrSetTermTypeStatusAction(axios: AxiosInstance) {
  return function hrSetTermTypeStatusAction({
    headers = {},
    parameters,
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: HrSetTermTypeStatusPathParameters;
    query?: HrSetTermTypeStatusQueryParameters;
    payload: HrSetTermTypeStatusPayload;
  }) {
    const path = hrSetTermTypeStatusActionPath.insert(parameters);

    return axios.request<HrSetTermTypeStatusResponse, HrSetTermTypeStatusResponse>({
      method: 'put',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
